import React, { useEffect, useState } from "react";
import { Box, makeStyles, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { ContactosContrataciones } from "./contactos/ContactosContrataciones";
import { DatosContablesContrataciones } from "./datosContables/DatosContablesContrataciones";
import { DocumentacionContrataciones } from "./documentacion/DocumentacionContrataciones";
import { InfoContrataciones } from "./informacion/InfoContrataciones";
import { CartillaContrataciones } from "./cartilla/CartillaContrataciones";
import { ConveniosContrataciones } from "./convenios/ConveniosContrataciones";
import { fetchProvincias } from "../../actions/cbos/provincias";
import { fetchLocalidades } from "../../actions/cbos/localidades";
import { useDispatch, useSelector } from "react-redux";
import { FetchMotivosBajaEfector } from "../../actions/contrataciones/configuraciones/abmMotivosBajaEfector";
import { AREAS_USUARIOS, MENU_CONTRATACIONES, SUBTIPO_EFECTORES, SUB_AREAS_CONTRATACIONES, /*TIPO_EFECTORES*/ } from "../../utils/constants";
import { ModulosContrataciones } from "./modulos/ModulosContrataciones";
import { InclusionesExclusiones } from "./inclusionesExclusiones/InclusionesExclusiones";
import { validarQueTengaAunqueSeaUnSoloPermiso, validarSoloUnPermiso } from "../../helpers/permisos";
import { CONTRATACIONES_CARTILLA_PERMISOS, CONTRATACIONES_CONTABLES_PERMISOS, CONTRATACIONES_CONTACTOS_CONTRATOS, CONTRATACIONES_CONVENIOS_PERMISOS, CONTRATACIONES_DOCUMENTACION_PERMISOS, CONTRATACIONES_INCLU_EXCLU_PERMISOS, CONTRATACIONES_INFORMACION_PERMISOS, CONTRATACIONES_LEGALES_PERMISOS, CONTRATACIONES_MODULOS_PERMISOS } from "../../utils/permisos";
import { LegalesContrataciones } from "./legales/LegalesContrataciones";
import { getCobraCoseguro } from "../../actions/cobraCoseguro";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "1rem",
    borderRadius: 5,
  },
}));

export const TabsContrataciones = ({ nuevo, setNuevo, ...props }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { dataContrato, presupuesto } = useSelector((state) => state.contrataciones);
  const { permisos: permisosUser, areas: areasUsuario, subAreasContrataciones } = useSelector((state) => state.auth);

  const [value, setValue] = useState("1");

  const [subTipoEfector, setSubTipoEfector] = useState();

  const isDisabled = dataContrato.idEfectorFacturacion === null;

  const tieneAreaContrataciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.CONTRATACIONES);

  const tieneAreaCompleta = tieneAreaContrataciones ? subAreasContrataciones.find((subArea) => subArea.idSubArea === SUB_AREAS_CONTRATACIONES.COMPLETA) : false;
  const tieneSubAreaLegales = tieneAreaContrataciones ? subAreasContrataciones.find((subArea) => subArea.idSubArea === SUB_AREAS_CONTRATACIONES.LEGALES) : false;
  const tieneSubAreaRRHH = tieneAreaContrataciones ? subAreasContrataciones.find((subArea) => subArea.idSubArea === SUB_AREAS_CONTRATACIONES.RRHH) : false;
  const tieneEnfermeriaOCmp = dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //Porque se usa en varios lados del alta
  useEffect(() => {
    dispatch(fetchProvincias());
    dispatch(fetchLocalidades());
    dispatch(FetchMotivosBajaEfector());
    dispatch(getCobraCoseguro());

  }, [dispatch]);

  useEffect(() => {
    setValue("1")
  }, [dataContrato])

  useEffect(() => {
    if (presupuesto && !nuevo) {
      setValue("6")
    }
  }, [presupuesto])

  return (
    <div className={classes.root}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Información" value="1" />
            <Tab disabled={
              isDisabled
            } label="Contactos" value="2" />
            <Tab
              disabled={
                isDisabled
              } label="Datos Contables" value="3" />
            <Tab disabled={
              isDisabled
            } label="Documentación" value="4" />
            <Tab
              disabled={
                isDisabled
                || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.HOSPITAL
                || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
                || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA
                || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR
                || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.COMPRAS_MEDICAS
              } label="Cartilla" value="5" />
            <Tab disabled={
              isDisabled
              //Comentado a pedido de Ana
              /*|| dataContrato?.idTipoEfector === TIPO_EFECTORES.INTEGRACION*/
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.COMPRAS_MEDICAS
            } label="Convenios" value="6" />
            <Tab disabled={
              isDisabled
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.COMPRAS_MEDICAS
            } label="Módulos" value="7" />
            <Tab disabled={
              isDisabled
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.ENFERMERIA
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.PROVEEDOR
              || dataContrato?.idSubTipoEfector === SUBTIPO_EFECTORES.COMPRAS_MEDICAS
            } label="Inclusiones / Exclusiones" value="8" />
            <Tab disabled={
              isDisabled
              || !tieneSubAreaLegales
            } label="Legales" value="9" />
          </TabList>
        </Box>

        <TabPanel value="1">
          <InfoContrataciones dataContrato={dataContrato} nuevo={nuevo} setNuevo={setNuevo}
            subTipoEfector={subTipoEfector}
            setSubTipoEfector={setSubTipoEfector}
            tieneSubAreaLegales={tieneSubAreaLegales}
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_INFORMACION_PERMISOS.ADMINISTRAR)
                || (tieneSubAreaRRHH && !nuevo ? !tieneEnfermeriaOCmp : !tieneSubAreaRRHH && !tieneAreaCompleta)
                || tieneSubAreaLegales
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
            menuLegales={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_INFORMACION_PERMISOS.ADMINISTRAR)
                || (tieneSubAreaRRHH && !nuevo ? !tieneEnfermeriaOCmp : !tieneSubAreaRRHH && !tieneAreaCompleta && !tieneSubAreaLegales)
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
            permisos={{
              tieneAreaCompleta, tieneSubAreaLegales, tieneSubAreaRRHH, tieneEnfermeriaOCmp
            }}
          />
        </TabPanel>
        <TabPanel value="2">
          <ContactosContrataciones
            idEfectorFacturacion={dataContrato.idEfectorFacturacion}
            menu={
              !validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [CONTRATACIONES_CONTACTOS_CONTRATOS])
                || (tieneSubAreaRRHH ? !tieneEnfermeriaOCmp : false && !tieneAreaCompleta && !tieneSubAreaLegales)
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
            permisos={permisosUser}
          />
        </TabPanel>
        <TabPanel value="3">
          <DatosContablesContrataciones
            subTipoEfector={subTipoEfector}
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONTABLES_PERMISOS.ADMINISTRAR)
                || (tieneSubAreaRRHH ? !tieneEnfermeriaOCmp : false && !tieneAreaCompleta)
                || tieneSubAreaLegales
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
            menuConsulta={props.menu === MENU_CONTRATACIONES.CONSULTA}
            tieneSubAreaLegales={tieneSubAreaLegales}
          />
        </TabPanel>
        <TabPanel value="4">
          <DocumentacionContrataciones
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_DOCUMENTACION_PERMISOS.ADMINISTRAR)
                || (tieneSubAreaRRHH ? !tieneEnfermeriaOCmp : false && !tieneAreaCompleta && !tieneSubAreaLegales)
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
            permisos={permisosUser}
          />
        </TabPanel>
        <TabPanel value="5">
          <CartillaContrataciones
            idEfectorFacturacion={dataContrato.idEfectorFacturacion}
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_CARTILLA_PERMISOS.ADMINISTRAR)
                || (tieneSubAreaRRHH ? !tieneEnfermeriaOCmp : false && !tieneAreaCompleta)
                || tieneSubAreaLegales
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
          />
        </TabPanel>
        <TabPanel value="6">
          <ConveniosContrataciones
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONVENIOS_PERMISOS.ADMINISTRAR)
                || tieneSubAreaRRHH || tieneSubAreaLegales || !tieneAreaCompleta
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
          />
        </TabPanel>
        <TabPanel value="7">
          <ModulosContrataciones
            idEfectorFacturacion={dataContrato.idEfectorFacturacion}
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_MODULOS_PERMISOS.ADMINISTRAR)
                || tieneSubAreaRRHH || tieneSubAreaLegales || !tieneAreaCompleta
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
          />
        </TabPanel>
        <TabPanel value="8">
          <InclusionesExclusiones
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_INCLU_EXCLU_PERMISOS.ADMINISTRAR)
                || tieneSubAreaRRHH || tieneSubAreaLegales || !tieneAreaCompleta
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
          />
        </TabPanel>
        <TabPanel value="9">
          <LegalesContrataciones
            menu={
              !validarSoloUnPermiso(permisosUser, CONTRATACIONES_LEGALES_PERMISOS.ADMINISTRAR)
                || !tieneSubAreaLegales
                ? MENU_CONTRATACIONES.CONSULTA : props.menu
            }
          />
        </TabPanel>
      </TabContext>
    </div>
  );
};